import React, {createContext, useContext} from 'react'
import useConfigPathStorage from '../hooks/localStorage/useConfigPathStorage';
import { getFolderName } from '../hooks/useConfigsNavigator';

const ConfigPathContext = createContext();

// -------------------------------  STATIC  ---------------------------------------- //
// const SelectorRootOrAbove =  /^\$\.rootAccount\.apps(\['[^']+'\]){7}.*/;
const SelectorRootOrAbove =  /^\$\.rootAccount(\['[^']+'\]){8}.*/;
export const isRootOrAbove = (aPath) => SelectorRootOrAbove.test(aPath);
export const ROOT_FOLDER_NAME = '/';
export const LEFT_BRACKET = "['";

export const getPath = (basePath, folderName) => `${basePath}['${folderName}']`;

export const getParentPath = (aPath) => {
  const folderName = getFolderName(aPath);
  if (ROOT_FOLDER_NAME !== folderName) {
    const lastLeftBracket = aPath.lastIndexOf(LEFT_BRACKET);
    const parentPath = aPath.substr(0, lastLeftBracket);
    return parentPath;
  }
  else {
    return null;
  }
}

export const getParentFolderName = (aPath) => getFolderName(getParentPath(aPath));
// --------------------------------------------------------------------------------- //


export default function ConfigPathContextProvider({children}) {
  const {configPath, setConfigPath} = useConfigPathStorage();

  const memoizedValue = {
    configPath, 
    setConfigPath
  }

  return (
    <ConfigPathContext.Provider value={memoizedValue}> {children} </ConfigPathContext.Provider>
  )
}

export function useConfigPathContext() {
  return useContext(ConfigPathContext);
}
